import { gql } from '@apollo/client';

export const ALL_WORK_ORDERS_QUERY = gql`
  query AllWorkOrders($domainId: Int!) {
    allWorkOrders(condition: { domainId: $domainId }, orderBy: CREATED_AT_DESC) {
      nodes {
        id
        description
        travelerNumber
        type
        status
        createdAt
        dueAt
        completedAt
        priority
        userByAssignedTo {
          id
          username
        }
        quoteByQuoteId {
          id
          name
          jobByJobId {
            id
            name
            customerByCustomerId {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const WORK_ORDER_BY_ID_QUERY = gql`
  query WorkOrderById($id: Int!) {
    workOrderById(id: $id) {
      id
      description
      travelerNumber
      type
      status
      notes
      designerClient
      createdAt
      dueAt
      completedAt
      quoteId
      assignedTo
      createdBy
      userByAssignedTo {
        id
        username
      }
      quoteByQuoteId {
        id
        name
        jobByJobId {
          id
          name
          customerByCustomerId {
            id
            name
          }
        }
      }
      workOrderLineItemsByWorkOrderId(orderBy: ITEM_NUMBER_ASC) {
        nodes {
          id
          itemNumber
          description
          quantity
          status
          notes
          draftQuoteObjectId
        }
      }
      workOrderImagesByWorkOrderId(orderBy: CREATED_AT_ASC) {
        nodes {
          id
          archivedAt
          draftQuoteObjectImageByDraftQuoteObjectImageId {
            id
            storedFilename
            originalFilename
          }
          quoteImageByQuoteImageId {
            id
            storedFilename
            originalFilename
          }
        }
      }
    }
  }
`;

export const UPDATE_WORK_ORDER_STATUS_MUTATION = gql`
  mutation UpdateWorkOrderStatus($id: Int!, $status: String!) {
    updateWorkOrderById(input: { id: $id, workOrderPatch: { status: $status } }) {
      workOrder {
        id
        status
      }
    }
  }
`;

export const UPDATE_WORK_ORDER_ASSIGNED_TO_MUTATION = gql`
  mutation UpdateWorkOrderAssignedTo($id: Int!, $assignedTo: Int) {
    updateWorkOrderById(input: { id: $id, workOrderPatch: { assignedTo: $assignedTo } }) {
      workOrder {
        id
        assignedTo
        userByAssignedTo {
          id
          username
        }
      }
    }
  }
`;

export const UPDATE_WORK_ORDER_PRIORITY_MUTATION = gql`
  mutation UpdateWorkOrderPriority($id: Int!, $priority: Int!) {
    updateWorkOrderById(input: { id: $id, workOrderPatch: { priority: $priority } }) {
      workOrder {
        id
        priority
      }
    }
  }
`;

export const UPDATE_WORK_ORDER_LINE_ITEM_STATUS_MUTATION = gql`
  mutation UpdateWorkOrderLineItemStatus($id: Int!, $status: String!) {
    updateWorkOrderLineItemById(input: { id: $id, workOrderLineItemPatch: { status: $status } }) {
      workOrderLineItem {
        id
        status
      }
    }
  }
`;

export const ALL_USERS_QUERY = gql`
  query AllUsers($domainId: Int!) {
    allUsers(condition: { domainId: $domainId, isActive: true }) {
      nodes {
        id
        username
        role
      }
    }
  }
`;

export const CREATE_WORK_ORDER_MUTATION = gql`
  mutation CreateWorkOrder(
    $domainId: Int!
    $quoteId: Int!
    $description: String!
    $status: String!
    $createdBy: Int!
    $assignedTo: Int
    $dueAt: Datetime
    $notes: String
    $travelerNumber: String
    $type: String
    $designerClient: String
  ) {
    createWorkOrder(
      input: {
        workOrder: {
          domainId: $domainId
          quoteId: $quoteId
          description: $description
          status: $status
          createdBy: $createdBy
          assignedTo: $assignedTo
          dueAt: $dueAt
          notes: $notes
          travelerNumber: $travelerNumber
          type: $type
          designerClient: $designerClient
        }
      }
    ) {
      workOrder {
        id
        description
        travelerNumber
        type
      }
    }
  }
`;

export const CREATE_WORK_ORDER_LINE_ITEM_MUTATION = gql`
  mutation CreateWorkOrderLineItem(
    $workOrderId: Int!
    $itemNumber: Int!
    $description: String!
    $quantity: BigFloat!
    $notes: String
    $quoteLineItemId: Int
    $draftQuoteObjectId: Int
  ) {
    createWorkOrderLineItem(
      input: {
        workOrderLineItem: {
          workOrderId: $workOrderId
          itemNumber: $itemNumber
          description: $description
          quantity: $quantity
          notes: $notes
          quoteLineItemId: $quoteLineItemId
          draftQuoteObjectId: $draftQuoteObjectId
        }
      }
    ) {
      workOrderLineItem {
        id
      }
    }
  }
`;

export const CREATE_WORK_ORDER_IMAGE_MUTATION = gql`
  mutation CreateWorkOrderImage(
    $workOrderId: Int!
    $draftQuoteObjectImageId: Int
    $quoteImageId: Int
  ) {
    createWorkOrderImage(
      input: {
        workOrderImage: {
          workOrderId: $workOrderId
          draftQuoteObjectImageId: $draftQuoteObjectImageId
          quoteImageId: $quoteImageId
        }
      }
    ) {
      workOrderImage {
        id
      }
    }
  }
`;
